import type { Map as MlMap } from 'maplibre-gl';

/**
 * Holds a reference to the *active* MapLibre instance for the current
 * workspace. Set by MapView when it mounts, cleared on unmount.
 * Consumed by code that needs to act on the map without prop-drilling —
 * e.g. the "Pre-cache current view" button in Settings.
 *
 * Replaces the previous `window.__fabricos_map` stash. Module-level so cross-
 * tree code (Settings ↔ MapView in a different workspace) can still find the
 * active map without a React provider above both subtrees.
 */
const ref: { current: MlMap | null } = { current: null };

/** Register / unregister an active map. MapView calls this in its effects. */
export function setActiveMap(m: MlMap | null): void {
  ref.current = m;
}

/** Plain getter — works from any module, hook or not. */
export function getActiveMap(): MlMap | null {
  return ref.current;
}
